import * as Sentry from '@sentry/angular';
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  ErrorHandler,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter, Router, withInMemoryScrolling, InMemoryScrollingOptions } from '@angular/router';
import { provideNgxStripe } from 'ngx-stripe';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { shareIcons } from 'ngx-sharebuttons/icons';
import {
  provideShareButtonsOptions,
  customShareButton,
  ShareButtonFuncArgs,
} from 'ngx-sharebuttons';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faBluesky } from '@fortawesome/free-brands-svg-icons';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';

const scrollConfig :InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled', // Optional: enables scrolling to anchors if available
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch()),
    provideShareButtonsOptions(
      shareIcons(),

      customShareButton('share-postcard-button', {
        type: 'custom-button',
        text: 'Share by Postcard',
        ariaLabel: 'Share by Postcard',
        icon: faPaperPlane,
        color: 'rgb(0, 92, 187)',
        func: (args: ShareButtonFuncArgs<any>) => {},
      }),
      customShareButton('bluesky', {
        type: 'custom-button',
        text: 'Share on BlueSky',
        ariaLabel: 'Share on BlueSky',
        icon: faBluesky,
        color: 'blue',
        share: {
          desktop: 'https://bsky.app/intent/compose',
        },
        params: {
          url: 'text',
          // define the needed parameters here
        },
      })
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling(scrollConfig)),
    provideAnimationsAsync(),
    provideNgxStripe(),
    provideClientHydration(withEventReplay()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
